import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrlService } from '@tenant/core/services/api-url.service';
import { ApiResponse } from '@app-shared/public-api';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor(
    private apiService: ApiService,
    private apiUrl: ApiUrlService,
  ) {}

  extractCsv(
    data: FormData,
  ): Observable<ApiResponse<{ row_count: number; data: string[][] }>> {
    return this.apiService.post(
      `${this.apiUrl.getApiUrl()}/line-officials/extract-csv-info`,
      data,
    );
  }
}
